import { RefinementCtx, ZodIssueCode, object, string } from "zod";

export const stockNumberSearchFormSchema = (errorText: string) =>
    object({
        stockNumber: string()
            .min(1, errorText)
            .trim()
            .transform((value: string, ctx: RefinementCtx): string => {
                if (!value) {
                    ctx.addIssue({
                        code: ZodIssueCode.custom,
                        message: errorText,
                    });
                }

                const parsedValue = parseInt(value);
                if (isNaN(parsedValue)) {
                    ctx.addIssue({
                        code: ZodIssueCode.custom,
                        message: errorText,
                    });
                } else if (parsedValue < 0) {
                    ctx.addIssue({
                        code: ZodIssueCode.custom,
                        message: errorText,
                    });
                }

                return value;
            }),
    });
